import {add} from "@tripetto/map/lib/observer";

export function addErrorOnBadPhoneNumber(){
    var iframe = document.querySelectorAll('#tripetto > iframe')[0];
/*
    var testElement = iframe.contentWindow.document.querySelectorAll('#_4c0502d429e0a02433658a0ed339b1234a989bd51e1f0f7711b0b504213546fe')[0];
    if(testElement){
        let phoneFieldValue = testElement.value;
        if(testValue(phoneFieldValue)){
            addMessage(iframe, testElement)
        }else{
            removeMessage(iframe)
        }
    }
*/


   // const selector= '.sc-fubCfw';
    const selector = '[inputmode="tel"]';
   // const selector = '#_4c0502d429e0a02433658a0ed339b1234a989bd51e1f0f7711b0b504213546fe'
    var phoneFields = iframe.contentWindow.document.querySelectorAll(selector);

    if(phoneFields.length>0){
        let phoneField = phoneFields[0];
        let phoneFieldValue = phoneField.value;
        console.log('tel: '+phoneFieldValue)


        if(testValue(phoneFieldValue)){
            addMessage(iframe, phoneField)
        }else{
            removeMessage(iframe)
        }
    }


}

function testValue(value){
    value = value.replaceAll(' ','')
    let regex1 = /^(\+33|0)[01234589]\d*$/i;
    let find1 = regex1.test(value);
    console.log(find1);

    let regex2 = /(0[0-9]){2,3}|1234567/i;
    let find2 = regex2.test(value);
    console.log(find2);
    return find1 || find2
}

function addMessage(iframe, element){
    var phoneErrorMessage = iframe.contentWindow.document.querySelectorAll('.phone-error-message');
    if(phoneErrorMessage.length==0){
        let p = document.createElement("p");
        p.innerHTML="Merci d'indiquer un numéro valide pour aller au bout de la simulation.\n\n" +
            'Si toutefois, vous souhaitez juste comparer <u>des taux</u> (comme on compare 2 aspirateurs &#128522;) sans aucune interaction avec un conseiller, rdv directement sur nos simulateurs en ligne : <a href="https://www.hellopret.fr/simulation/simulateur-pret-immobilier/">https://www.hellopret.fr/simulation/simulateur-pret-immobilier/</a>';
        p.classList.add("phone-error-message");
        p.style.color = "darkred";
        element.after(p);
    }
}
function removeMessage(iframe, element){
    var phoneErrorMessage = iframe.contentWindow.document.querySelectorAll('.phone-error-message');
    if(phoneErrorMessage.length>0){
        phoneErrorMessage[0].remove()
    }
}